export default "__VITE_ASSET__Z3gDo_jV__"